import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { fetchVacationRentalShop } from "../../actions/actions";
import { withRouter } from "react-router";
import {
  getFromDate,
  getUntilDate,
  getNightCount,
  getAdultsCount,
  getChildren,
  getPetsCount,
} from "../../../search/reducer";
import { getVacationRentalShopSelectedListing } from "../../reducer/selectors";
import { setFromDate, setUntilDate } from "../../../search/actions/actions";
import { MobileDateSelector } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    selectedListing: getVacationRentalShopSelectedListing(state),
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    lengthOfStay: getNightCount(state),
    numAdults: getAdultsCount(state),
    numChildren: getChildren(state),
    numPets: getPetsCount(state),
  };
};

const mapDispatchToProps = {
  fetchVacationRentalShop,
  setFromDate,
  setUntilDate,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileDateSelectorConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMobileDateSelector = withRouter(
  connector(MobileDateSelector)
);
